import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode } from "..";
import { dataFetchReducer } from './utils/dataFetchReducer';
import { parseFavoriteOdds } from './parseFavoriteOdds';
import { getConfiguration } from './utils/configuration';

let source = null;

export function useFetchFavoriteOdds() {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
        newData: null
    });
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            if (source != null) {
                source.cancel();
            }
            source = axios.CancelToken.source();
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {cancelToken: source.token, params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getFavoriteOdds;
        const params = {
            systemCode,
            hash: '',
        };
        fetchData(url, params, function(response) {
            const data = parseFavoriteOdds(response);
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
